import KeyValuePair from '@/modules/core/support/KeyValuePair';

export default class UserPlaform {
    public id = ''
    public name = ''
    public email = ''
    public numeroDeSerie = ''
    public tema = ''
    public urlServer = ''
    public clave = ''
    public bloqueado = false
    public emailConfirmed = false
    public phoneNumberConfirmed = false
    public tokenc = ''
    public notificaciones = new Array<string>()
    public advertencias = new Array<string>()
    public errores = new Array<string>()
    public apiUnigest = ''
    public found = false // encontrado/existe
    public rem = ''

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id,
            name: data.name,
            email: data.email,
            numeroDeSerie: data.numeroDeSerie,
            tema: data.tema,
            urlServer: data.urlServer,
            clave: data.clave,
            bloqueado: data.bloqueado,
            emailConfirmed: data.emailConfirmed,
            phoneNumberConfirmed: data.phoneNumberConfirmed,
            tokenc: data.tokenc,
            notificaciones: data.notificaciones,
            advertencias: data.advertencias,
            errores: data.errores,
            apiUnigest: data.apiUnigest,
            found : data.found,
            rem: data.rem,
        })
    }
}
